export default "__VITE_ASSET__CzgmvVf6__"